import {Typography} from '@mui/material';
import React from 'react';
import Box from '@mui/material/Box';
import { DataGrid, GridColDef } from '@mui/x-data-grid';

interface PendingOrdersProps {
  pendingOrders: PendingOrder[];
  autoPilotSettingsKey: number;
}

interface PendingOrder {
  autoPilotOrderKey?: number;
  autoPilotSettingsKey?: number;
  symbol?: string;
  positionType?: string;
  price?: number;
  quantity?: number;
  orderSide?: string;
  positionEffect?: string;
  orderStatus?: string;
  orderState?: string;
  strikePrice?: number;
  optionType?: string;
  expirationDate?: Date;
  assetKey?: number;
}

export const PendingOrdersTable = ({ pendingOrders, autoPilotSettingsKey }: PendingOrdersProps) => {

  const columns: GridColDef[] = [
    { field: 'symbol',         headerName: 'Symbol',         width: 120 },
    { field: 'positionType',   headerName: 'Position Type',  width: 100 },
    {
      field: 'price',
      headerName: 'Price',
      type: 'number',
      width: 100,
    },
    {
      field: 'quantity',
      headerName: 'Quantity',
      type: 'number',
      width: 100,
    },
    { field: 'orderSide',      headerName: 'Side',           width: 80 },
    { field: 'positionEffect', headerName: 'Effect',         width: 80 },
    { field: 'orderStatus',    headerName: 'Status',         width: 150 },
    { field: 'orderState',     headerName: 'State',          width: 100 },
    {
      field: 'strikePrice',
      headerName: 'Strike Price',
      type: 'number',
      width: 120,
    },
    { field: 'optionType',     headerName: 'Option Type',    width: 120 },
    {
      field: 'expirationDate',
      headerName: 'Expiration',
      type: 'date',
      width: 130,
    },
  ];

  const rows = pendingOrders.map((row: PendingOrder, index: number) => {
    return {
      id: index,
      ...row,
    }
  });

  return (
    <Box>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="flex-start"
        gap={1}
        mb={1}
      >
        <Typography
          variant="subtitle1"
          component="div"
          align="left"
          sx={{
            color: '#6D6D6D',
            fontFamily: 'Roboto',
            fontWeight: 500,
            fontSize: '13px',
            lineHeight: '12px',
            letterSpacing: '0.05em',
          }}
        >
          PENDING ORDERS
        </Typography>
      </Box>

      <DataGrid
        rows={rows}
        columns={columns}
        rowHeight={40}
        hideFooter
        sx={{ height: '20rem' }}
      />
    </Box>
  )

}